/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Primary_ToolbarInputs */



/**
* | output |
* | --- |
* | "Primary Toolbar" |
*
* @param {Primary_ToolbarInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const primary_toolbar = /** @type {((inputs?: Primary_ToolbarInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Primary_ToolbarInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Barre d'outils principale")
	if (locale === "de") return /** @type {LocalizedString} */ ("Primäre Symbolleiste")
	if (locale === "it") return /** @type {LocalizedString} */ ("Barra degli strumenti principale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Основная панель инструментов")
	if (locale === "es") return /** @type {LocalizedString} */ ("Barra de herramientas principal")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("主工具栏")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プライマリツールバー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्राथमिक टूलबार")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Barra de ferramentas principal")
	return /** @type {LocalizedString} */ ("Primary Toolbar")
});